import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { CoreDirectivesModule } from '@core/directives/directives';
import { CorePipesModule } from '@core/pipes/pipes.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CoreDirectivesModule, CorePipesModule, TranslateModule],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, CoreDirectivesModule, CorePipesModule, TranslateModule]
})
export class CoreCommonModule { }
